import React from 'react'
import { Bar } from 'react-chartjs-2'

const InboundOutboundChart = ({ inboundOutboundDistribution }) => {
  const data = {
    labels: ['Good', 'Minor Defect', 'Major Defect'],
    datasets: [
      {
        label: 'Inbound',
        data: [
          inboundOutboundDistribution?.inboundGood || 0,
          inboundOutboundDistribution?.inboundMinorDefect || 0,
          inboundOutboundDistribution?.inboundMajorDefect || 0,
        ],
        backgroundColor: '#4e95d9',
      },
      {
        label: 'Outbound',
        data: [
          inboundOutboundDistribution?.outBoundGood || 0,
          inboundOutboundDistribution?.outBoundMinorDefect || 0,
          inboundOutboundDistribution?.outBoundMajorDefect || 0,
        ],
        backgroundColor: '#215f9a',
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      fullWidth: false,
    },
    hover: {
      mode: null,
    },
    tooltips: {
      enabled: false,
      custom: () => false,
      mode: null,
    },
    title: {
      display: true,
      text: 'Inbound vs Outbound Distribution',
      fontSize: 20,
      fontColor: '#2a496c',
      fontWeight: 600,
    },
    animation: {
      duration: 0,
      onComplete(animation) {
        const { chart } = animation
        const { ctx } = chart
        ctx.textAlign = 'center'
        ctx.textBaseline = 'bottom'
        ctx.font = 'bold 15px Arial'

        chart.data.datasets.forEach((dataset, i) => {
          const meta = chart.controller.getDatasetMeta(i)
          meta.data.forEach((bar, index) => {
            const data = `${dataset.data[index]}%`
            ctx.fillStyle = '#000'
            ctx.fillText(data, bar._model.x, bar._model.y - 5)
          })
        })
      },
    },
  }

  return <Bar options={options} data={data} height={400} />
}

export default InboundOutboundChart
